import styled, { css } from 'styled-components';

export const SkiliftMarkerContainer = styled.div<{ hover: boolean }>`
  background-color: ${({ theme }) => theme.kallisto.color.common.semantic.info[500]};
  width: 16px;
  height: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  ${({ hover }) =>
    hover &&
    css`
      transform: scale(1.5);
    `}
`;

export const SkiliftPopup = styled.div``;
